import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { CHANNELS } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import RnaId from '../RnaId';

import './ListingDescriptionsModal.scss';

const openListingDescriptionsModal = ({
  listingDescription = '',
  landlordDescription = '',
  roomDescription = '',
  whatWeLiked = '',
  thingsToKeepInMind = '',
  rnaIdFeature = null,
  fullscreenOnMobile = false
} = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('listing.descriptions.title'),
    body: (
      <>
        {landlordDescription && (
          <div className="listing-descriptions-modal__section">
            <ListingTitle role="tertiary">
              {trans('listing.overview.landlord.description.title')}
            </ListingTitle>
            <ListingContent content={landlordDescription} />
          </div>
        )}
        {listingDescription && (
          <div className="listing-descriptions-modal__section">
            <ListingTitle role="tertiary">
              {trans('listing.overview.description.title')}
            </ListingTitle>
            <ListingContent content={listingDescription} />
          </div>
        )}
        {roomDescription && (
          <div className="listing-descriptions-modal__section">
            <ListingTitle role="tertiary">
              {trans('property_show.title.room_description')}
            </ListingTitle>
            <ListingContent content={roomDescription} />
          </div>
        )}
        {whatWeLiked && (
          <div className="listing-descriptions-modal__section">
            <ListingTitle role="tertiary">
              {trans('property_show.title.like_most')}
            </ListingTitle>
            <ListingContent content={whatWeLiked} />
          </div>
        )}
        {thingsToKeepInMind && (
          <div className="listing-descriptions-modal__section">
            <ListingTitle role="tertiary">
              {trans('property_show.title.keep_mind')}
            </ListingTitle>
            <ListingContent content={thingsToKeepInMind} />
          </div>
        )}
        {rnaIdFeature && rnaIdFeature?.value !== 'no' && (
          <RnaId
            className="listing-descriptions-modal__section listing-descriptions-modal__section-rna-id-content"
            rnaIdFeature={rnaIdFeature}
          />
        )}
      </>
    ),
    fullscreenOnMobile
  });
};

export default openListingDescriptionsModal;
